var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"header container-fluid"},[_c('div',{staticClass:"row h-100 align-items-center"},[_c('div',{staticClass:"col d-flex align-items-center"},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('span')]),_c('h3',[_vm._v("OZG Manager")])])])])])
}]

export { render, staticRenderFns }